import {
  subYears,
  getEndOfDay,
  getStartOfDay,
} from '@querodelivery/qd-date-helper';
import isEmpty from 'lodash/isEmpty';
import { Card } from '@quero-delivery/quero-components-web';
import { ExtractList } from './components/extract-list';
import { ButtonSeeAllList } from '../motoboy-details/components/button-see-all-list';
import styles from './extract.module.scss';
import { useGetExtracts } from './api/get-extracts';
import { Skeleton } from '@/_config/lib/react-native-skeleton';

function Extract({
  deliverymanId,
  hasMore,
}: {
  deliverymanId: string;
  hasMore?: () => void;
}) {
  const LIMIT = 3;

  const { data: extractData, isLoading } = useGetExtracts({
    limit: LIMIT,
    deliverymanId,
    startDate: getStartOfDay(subYears(new Date(), 10)).toISOString(),
    endDate: getEndOfDay(new Date()).toISOString(),
  });

  const { results: extracts, total_count: totalCount } =
    extractData?.data || {};

  const hasMoreExtracts = totalCount && totalCount > LIMIT;

  if (!extracts || isEmpty(extracts)) {
    return <p className="text-center">Nenhum extrato encontrado</p>;
  }

  return (
    <Card type="none" className={styles.card} loading={isLoading}>
      {isLoading ? (
        <div className={styles.extractsSkeletonContainer}>
          <div className={styles.extractsSkeletonTitleContainer}>
            <Skeleton height={15} borderRadius={8} width="5vw" />
            <Skeleton height={15} borderRadius={8} width="10vw" />
          </div>
          <Skeleton height={164} borderRadius={8} style={{ flex: 1 }} />
        </div>
      ) : (
        <>
          <div className={styles.containerLabel}>
            <span>Últimas transações</span>
            <span>
              {`${totalCount} ${totalCount === 1 ? 'extrato' : 'extratos'}`}
            </span>
          </div>
          <ExtractList extracts={extracts} totalCount={totalCount || 0} />
          {hasMoreExtracts ? (
            <ButtonSeeAllList onClick={hasMore || undefined} />
          ) : null}
        </>
      )}
    </Card>
  );
}

export { Extract };
